// EXTERNAL DEPENDENCIES
import React from 'react'

// HELPERS
import {
  useBusinessProfilePageContent,
  useBusinessProfileReduxState,
} from '../../hooks'

// COMPONENTS
import { BodyText, Row } from '@paypalcorp/pp-react'
import { WithLoadingShimmer } from '@/common/components/loading/with-loading-shimmer'

// CONSTANTS
import { BUSINESS_NAME_SECTION_TEST_ID } from '../../constants/test-ids'

// STYLES
import styles from './styles.module.less'

/**
 * Displays a bold Business name label and the business name
 * that shimmers until present
 */
export function BusinessNameSection() {
  const {
    editedProfileData: { values },
  } = useBusinessProfileReduxState()

  const getContent = useBusinessProfilePageContent()
  const businessNameLabelText = getContent('businessName')

  return (
    <div
      className={styles.sectionContainer}
      data-testid={BUSINESS_NAME_SECTION_TEST_ID}
    >
      <Row noGutters className={styles.businessNameLabelContainer}>
        <BodyText strong>{businessNameLabelText}</BodyText>
      </Row>
      <WithLoadingShimmer isLoading={!values?.businessName}>
        <Row noGutters className={styles.businessNameContainer}>
          <BodyText>{values?.businessName}</BodyText>
        </Row>
      </WithLoadingShimmer>
    </div>
  )
}
